import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import BikeRecommendation from './pages/BikeRecommendation';
import AboutUs from './pages/AboutUs';
import Feedback from './pages/Feedback';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className='App'>
        <Navbar />
        <div className='main-content'>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/recommendations' element={<BikeRecommendation />} />
            <Route path='/about' element={<AboutUs />} />
            <Route path='/feedback' element={<Feedback />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
